import { render, staticRenderFns } from "./CertificatsView.vue?vue&type=template&id=52a43fc2"
import script from "./CertificatsView.vue?vue&type=script&lang=js"
export * from "./CertificatsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports